import React from "react";

import styles from "~/styles/styles.css?url";

import { LinksFunction } from "react-router";
import { Link, Links, Meta, Scripts, useFetcher } from "react-router";
import { Issue } from "./types/generated/proto/db/models/Issue";

export function meta() {
	return [
		{ name: "charset", content: "utf-8" },
		{ name: "title", content: "Lab" },
		{ name: "viewport", content: "width=device-width,initial-scale=1" }
	];
}

export const links: LinksFunction = () => {
	return [
		{ rel: "stylesheet", href: styles },
		{ rel: "stylesheet", href: "https://cdnjs.cloudflare.com/ajax/libs/remixicon/4.6.0/remixicon.min.css" },
	];
};

export default function ErrorPage({ message, date }: { message: string, date: string }) {
	const issueFetcher = useFetcher<Issue>();

	const reload = () => {
		issueFetcher.load("/api/latestIssue");
	};

	return (
		<html lang="de" className="cs-no-scrolling cs-no-selection">
			<head>
				<Meta />
				<Links />
			</head>
			<body className="cs-no-scrolling">
				<section className="hero is-primary is-large cs-fh-view cs-background-color-primary">
					<div className="hero-body cs-padding-top-10rem">
						<div className="columns">
							<div className="column"></div>
							<div className="column">
								<div className="card">
									<header className="card-header">
										<p className="card-header-title">Fehler</p>
										<div className="card-header-icon">
											<span className="icon">
												<i className="ri-error-warning-line" aria-hidden="true"></i>
											</span>
										</div>
									</header>
									<div className="card-content">

										<h2 className="title is-2 cs-text-black">Ups!</h2>
										<div className="block">
											Ein Fehler ist aufgetreten und der aktuelle Vorgang wurde beendet.
										</div>

										<div className="columns">
											<div className="column">
												<h5 className="title is-5 cs-text-black">Server-Log</h5>
											</div>
											<div className="column narrow has-text-right">
												<button type="button" className="button is-rounded" onClick={reload}>
													<span className="icon">
														<i className="ri-loop-left-line"></i>
													</span>
												</button>
											</div>
										</div>

										<div className="block">
											<textarea className="textarea" readOnly placeholder="Server-Log manuell aktualisieren" value={issueFetcher.data ? (issueFetcher.data?.timestamp + "\n" + issueFetcher.data?.error + "\n" + issueFetcher.data?.args) : ""}></textarea>
										</div>

										<h5 className="title is-5 cs-text-black">Client-Log</h5>
										<div className="block">
											<textarea className="textarea" readOnly value={date + "\n" + message}></textarea>
										</div>

										<div className="field is-grouped is-grouped-centered">
											<p className="control">
												<Link reloadDocument to="/" className="button is-link">Startseite</Link>
											</p>
										</div>

									</div>
								</div>

							</div>
							<div className="column"></div>
						</div>
					</div>
				</section>
				<Scripts />
			</body>
		</html>
	);
}